<template>
  <div>
    <h3 class="text-lg">Status</h3>
    <div class="mt-4">
      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'status_is' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="status"
            id="status_is"
            value="status_is"
          />
          <label for="status_is" class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Status is</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'status_is'"
          v-model="valueByStatus.status_is"
          :options="statusOptions"
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'status_is_not' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="status"
            id="status_is_not"
            value="status_is_not"
          />
          <label
            for="status_is_not"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Status is not</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'status_is_not'"
          v-model="valueByStatus.status_is_not"
          :options="statusOptions"
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'status_in' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="status"
            id="status_in"
            value="status_in"
          />
          <label for="status_in" class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Status is one of</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'status_in'"
          v-model="valueByStatus.status_in"
          :options="statusOptions"
          multiple
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'status_not_in' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="status"
            id="status_not_in"
            value="status_not_in"
          />
          <label
            for="status_not_in"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Status is not one of</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'status_not_in'"
          v-model="valueByStatus.status_not_in"
          :options="statusOptions"
          multiple
        />
      </div>
    </div>
    <div class="mt-5 flex space-x-3">
      <div class="flex-none">
        <button
          type="button"
          class="relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
      <div class="flex-1">
        <button
          type="button"
          class="w-full relative text-center items-center px-4 py-2 text-sm font-medium rounded-md bg-blue-600 text-white border border-transparent focus:outline-none focus:ring ring-blue-500 ring-opacity-50 focus:border-blue-700"
          @click="applyFilter"
        >
          Apply Filter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const statusOptions = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Processing',
    value: 'processing',
  },
  {
    label: 'On-hold',
    value: 'on-hold',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
  {
    label: 'Refunded',
    value: 'refunded',
  },
  {
    label: 'Failed',
    value: 'failed',
  },
  {
    label: 'Trash',
    value: 'trash',
  },
];

export default {
  data() {
    return {
      selectedFilter: null,
      value: '',
      statusOptions: [...statusOptions],
      valueByStatus: {
        status_is: null,
        status_is_not: null,
        status_in: [],
        status_not_in: [],
      },
    };
  },
  methods: {
    applyFilter() {
      this.$emit('apply-filter', {
        key: this.selectedFilter,
        value: this.valueByStatus[this.selectedFilter],
      });
    },
  },
};
</script>
